import React, { FC } from 'react'
import ContentRow from './ContentRow'
import { FormattedDate, FormattedMessage, useIntl } from 'react-intl'
import messages from '@utils/messages'
import { Grid, Typography, useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { orderCenterRoutes } from '@src/routes'
import { Link } from '@src/components/Link'
import { sendCommonDetailClickEvent } from '@src/utils/analytics'
import {
  DejaNewEventCategory as eventCategory,
  DejaNewEventAction as eventAction,
  DejaNewEventLabel as eventLabel,
} from '@utils/analytics/enums'
import { SharedList } from '@src/types/graphql-types'
import { getListName } from '@src/routes/SharedList/utils'

const Lists: FC<{
  lists: SharedList[]
  handleListClick: (data: any) => void
  noListsItems: boolean
}> = ({ lists, handleListClick, noListsItems }) => {
  const theme = useTheme()
  const isLarge = useMediaQuery(theme.breakpoints.up('lg')) === true
  const { formatMessage } = useIntl()

  return (
    <>
      {lists.length === 0 || noListsItems ? (
        <ContentRow
          firstColumn={<FormattedMessage {...messages.NO_LISTS_ADDED_YET} />}
        />
      ) : (
        <>
          {lists.map((list, index) => (
            <ContentRow
              key={index}
              firstColumn={getListName(formatMessage)(list)}
              onClick={() => handleListClick(list)}
              secondColumn={
                <Typography variant="body2" align={!isLarge ? 'left' : 'right'}>
                  <FormattedDate
                    value={new Date(list.lastUpdatedDate)}
                    year="numeric"
                    month="short"
                    day="numeric"
                  />
                </Typography>
              }
            />
          ))}
        </>
      )}
      <Grid
        item
        xs={12}
        onClick={() =>
          sendCommonDetailClickEvent(
            {
              event: 'quick_order_widget_interaction',
              action: 'visit all lists',
              section: 'add to quick order',
              component: 'right rail',
              elementType: 'link',
              elementText: 'go to lists',
              linkUrl: orderCenterRoutes.lists(),
              coreEvent: 'no',
            },
            {
              eventCategory: eventCategory.QuickOrderPage,
              eventAction: eventAction.Lists,
              eventLabel: eventLabel.GoToLists,
              eventInteractionType: 0,
            }
          )
        }
      >
        <Link href={orderCenterRoutes.lists()}>
          <a>
            <FormattedMessage {...messages.GO_TO_LISTS} />
            {' >'}
          </a>
        </Link>
      </Grid>
    </>
  )
}

export default Lists
